module.exports = {
  respDashboardEvents: {
    RespHome: {
      code: 'RespHome',
      events: {
        Load: {
          description: 'Triggered when the RESP dashboard is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'RESP_Dashboard_Loaded'
          },
          ga: {
            action: 'RESP_Dashboard_Loaded'
          }
        },
        CtaClick: {
          description:
            'Triggered when the a CTA button is clicked on the RESP dashboard.',
          eventHub: {
            code: 'OnClickCta',
            action: 'RESP_[$.action]CTA_Clicked'
          },
          ga: {
            action: 'RESP_[$.action]CTA_Clicked'
          }
        },
        ReferClick: {
          description:
            'Triggered when refer a friend CTA is clicked on the RESP dashboard',
          eventHub: {
            code: 'REFER_CLICK',
            action: 'MainDashboard_Clicked Refer a friend right rail card'
          }
        },
        GiftingClick: {
          description:
            'Triggered when gifting CTA is clicked on the RESP dashboard',
          eventHub: {
            code: 'GIFTING_CLICK',
            action: 'RightRail_Sharegiftinglink_Clicked'
          }
        },
        MessageIconClick: {
          description:
            'Triggers when user clicks on the message icon in the dashboard',
          eventHub: {
            code: 'MESSAGE_CLICK',
            action: 'Dashboard_Clicked messages icon'
          }
        }
      }
    },
    Money: {
      code: 'Money',
      events: {
        CardClick: {
          description: 'Triggered when a card is clicked on the Money page.',
          eventHub: {
            code: 'OnCardClick',
            action: 'RESP_Money_[$.action]_Clicked'
          },
          ga: {
            action: 'RESP_Money_[$.action]_Clicked'
          }
        }
      }
    },
    Rewards: {
      code: 'Rewards',
      events: {
        DetailsClick: {
          description:
            'Triggered when a "See details" button is clicked on the offers page.',
          eventHub: {
            code: 'OnClickDetails',
            action: 'RESP_Rewards_[$.action]_Clicked'
          },
          ga: {
            action: 'RESP_Rewards_[$.action]_Clicked'
          }
        },
        OfferClick: {
          description:
            'Triggered when an offer card is clicked on the offers page.',
          eventHub: {
            code: 'OnClickOffer',
            action: 'RESP_Rewards_Offer_Clicked',
            dataKeys: ['partner']
          },
          ga: {
            action: 'RESP_Rewards_Offer_Clicked'
          }
        }
      }
    },
    Settings: {
      code: 'Settings',
      events: {
        PersonalInfoClick: {
          description:
            'Triggered when the "Personal information" card is clicked on the settings page.',
          eventHub: {
            code: 'OnClickPersonalInfo',
            action: 'RESP_Settings_PersonalInfo_Clicked'
          },
          ga: {
            action: 'RESP_Settings_PersonalInfo_Clicked'
          }
        }
      }
    },
    Documents: {
      code: 'Documents',
      events: {
        FilterClick: {
          description:
            'Triggered when a filter button is clicked on the documents page.',
          eventHub: {
            code: 'OnClickFilter',
            action: 'RESP_Documents_[$.action]_Clicked'
          },
          ga: {
            action: 'RESP_Documents_[$.action]_Clicked'
          }
        }
      }
    },
    RemindCoSubDialog: {
      code: 'RemindCoSubDialog',
      events: {
        Load: {
          description: 'Triggered when the co-sub reminder dialog is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'RESP_CoSubReminder_SendReminder_Loaded'
          },
          ga: {
            action: 'RESP_CoSubReminder_SendReminder_Loaded'
          }
        },
        CtaClick: {
          description:
            'Triggered when the CTA button is clicked on the co-sub reminder dialog.',
          eventHub: {
            code: 'OnClickCta',
            action: 'RESP_CoSubReminder_SendReminder_Clicked'
          },
          ga: {
            action: 'RESP_CoSubReminder_SendReminder_Clicked'
          }
        }
      }
    },
    AddChildOfferCard: {
      code: 'AddChildOfferCard',
      events: {
        CardClick: {
          description:
            'Triggered when the "Add a child" offer card is clicked on the RESP dashboard.',
          eventHub: {
            code: 'OnClickCard',
            action: 'RESP_AddChildOffer_CardClicked'
          },
          ga: {
            action: 'RESP_AddChildOffer_CardClicked'
          }
        },
        CtaClick: {
          description:
            'Triggered when the "Add a child" offer card CTA button is clicked on the RESP dashboard.',
          eventHub: {
            code: 'OnClickCta',
            action: 'RESP_AddChildOffer_CTAClicked'
          },
          ga: {
            action: 'RESP_AddChildOffer_CTAClicked'
          }
        }
      }
    },
    AddChildOfferDialog: {
      code: 'AddChildOfferDialog',
      events: {
        Load: {
          description:
            'Triggered when the "Add a child" offer popup is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'RESP_Dashboard_AddChildOffer_Popup_Loaded'
          },
          ga: {
            action: 'RESP_Dashboard_AddChildOffer_Popup_Loaded'
          }
        },
        CtaClick: {
          description:
            'Triggered when the "Add a child" offer popup CTA button is clicked.',
          eventHub: {
            code: 'OnClickCTA',
            action: 'RESP_Dashboard_AddChildOffer_Popup_CTAClicked'
          },
          ga: {
            action: 'RESP_Dashboard_AddChildOffer_Popup_CTAClicked'
          }
        }
      }
    },
    BillPaymentDialog: {
      code: 'BILL_PAYMENT_DIALOG',
      events: {
        CtaClick: {
          description:
            'Triggered when the bill payment dialog popup CTA is clicked.',
          eventHub: {
            code: 'OnClickCTA',
            action: 'RightRail_BillPaymentCard_Clicked'
          }
        }
      }
    },
    NavigationMenu: {
      code: 'NAVIGATION_MENU',
      events: {
        GiftingLinkClick: {
          description:
            'Triggered when the gifting link in the navigation menu is clicked.',
          eventHub: {
            code: 'GIFTING__CLICKED',
            action: 'NavigationMenu_Gifting_Clicked'
          }
        }
      }
    }
  }
};
